import script from "./IncomeStatementView.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatementView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__